import { create } from 'zustand';

import { PaymentSteps } from '@mopla/data-models';

interface IPaymentStepStore {
	step: PaymentSteps;
	isOpened: boolean;

	setStep: (step: PaymentSteps) => void;
	setIsOpened: (isOpened: boolean) => void;
	reset: () => void;
}

const initialState: Pick<IPaymentStepStore, 'step' | 'isOpened'> = {
	step: 'selection',
	isOpened: false,
};

export const usePaymentStepStore = create<IPaymentStepStore>()((set) => ({
	...initialState,

	setStep: (step) => set({ step }),
	setIsOpened: (isOpened) => set({ isOpened }),

	reset: () => set(initialState),
}));
